import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_payment_method_item = _resolveComponent("payment-method-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_ctx.isGranted('SELECT_PAYMENT_METHOD'))
    ? (_openBlock(), _createBlock(_component_q_select, _mergeProps({
        key: 0,
        "model-value": _ctx.modelValue,
        options: _ctx.paymentMethods,
        "option-value": "id",
        label: _ctx.modelValue ? 'Payment Method' : 'Select a Payment Method',
        loading: _ctx.isLoading,
        "map-options": !_ctx.object
      }, _ctx.$attrs, { "onUpdate:modelValue": _ctx.select }), {
        option: _withCtx((scope) => [
          _createVNode(_component_payment_method_item, _mergeProps({
            "payment-method": scope.opt
          }, scope.itemProps), null, 16, ["payment-method"])
        ]),
        "selected-item": _withCtx((scope) => [
          (_ctx.isObject(scope.opt))
            ? (_openBlock(), _createBlock(_component_payment_method_item, {
                key: 0,
                class: "q-px-none",
                "payment-method": scope.opt,
                onClick: ($event: any) => (_ctx.select(scope.opt))
              }, null, 8, ["payment-method", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 16, ["model-value", "options", "label", "loading", "map-options", "onUpdate:modelValue"]))
    : _createCommentVNode("", true)
}